export default {
    items: [
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'full-name',
                    width: 0,
                    props: {
                        hidden: true,
                        formula: {
                            name: 'join',
                            arguments: {
                                targets: [
                                    'first-name',
                                    'last-name'
                                ]
                            }
                        }
                    }
                },
                {
                    type: 'text-field',
                    name: 'first-name',
                    width: 6,
                    props: {
                        label: 'First Name'
                    }
                },
                {
                    type: 'text-field',
                    name: 'last-name',
                    width: 6,
                    props: {
                        label: 'Last Name'
                    }
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'ss-number',
                    width: 6,
                    props: {
                        label: 'Social Security Number',
                        tooltip: 'This will be obtained on the phone.',
                        readonly: true,
                        placeholder: "XXX-XXX-XXXX"
                    }
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'address',
                    width: 12,
                    props: {
                        label: 'Notice Address'
                    },
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'city',
                    width: 6,
                    props: {
                        label: 'City'
                    }
                },
                {
                    type: 'selectlist',
                    name: 'state',
                    width: 2,
                    props: {
                        label: 'State',
                        items: [
                            // TODO: Swap States
                            {
                                text: 'swap-states',
                                value: 'swap-states'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    name: 'zip',
                    width: 4,
                    props: {
                        label: 'Zip'
                    }
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'shares',
                    width: 4,
                    props: {
                        label: 'Number of Units/Shares',
                        format: 'number'
                    }
                },
                {
                    type: 'text-field',
                    name: 'tax-year-end',
                    width: 4,
                    props: {
                        label: 'End of Shareholder\'s Tax Year'
                    }
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'contribution-amount',
                    width: 4,
                    props: {
                        label: 'Amount of Contribution',
                        format: 'dollars'
                    }
                },
                {
                    type: 'text-field',
                    name: 'contribution-type',
                    width: 4,
                    props: {
                        label: 'Type of Contribution'
                    }
                }
            ]
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/entity-new/data_table_forms/shareholder-member.js